import React from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

export default function ExpertImpactCard({ experts, impact, onOpenDrawer }) {
  const totals = experts?.totals || {};
  const impactSummary = impact?.summary || {};
  const items = Array.isArray(impact?.items) ? impact.items : [];
  const hiddenLowSample = items.filter((item) => item?.hiddenByLowSample).length;

  return (
    <section className="min-h-[248px] rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-black text-slate-900 dark:text-white">Uzman Etki Görünümü</h3>
          <PanelHelpBadge
            title="Uzman Etki Görünümü"
            description="Uzman etkisini örneklem ve güven düzeyi bağlamında karar odaklı gösterir."
            interpretation="Düşük örneklemli uzmanlar görünse bile skor kararında tek başına kullanılmamalıdır."
            metricExample="Ortalama etki artarken aktif uzman sabitse eşleşme kalitesi güçlenmiş olabilir."
            side="left"
          />
        </div>
        <button
          type="button"
          onClick={() => onOpenDrawer('expert')}
          className="text-xs font-bold text-primary hover:underline"
        >
          Detaya git →
        </button>
      </div>

      <p className="mt-3 text-2xl font-black text-slate-900 dark:text-white">
        {Number(impactSummary.averageImpactScore || 0).toLocaleString('tr-TR')}
      </p>
      <p className="text-xs text-slate-500 dark:text-slate-400">Ortalama impact skoru</p>

      <ul className="mt-3 space-y-1.5 text-sm">
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Toplam uzman</span>
          <span className="font-black text-slate-900 dark:text-white">{Number(totals.totalExperts || 0).toLocaleString('tr-TR')}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">D7 aktif uzman</span>
          <span className="font-black text-slate-900 dark:text-white">{Number(totals.d7ActiveExperts || 0).toLocaleString('tr-TR')}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Aktif ilişki</span>
          <span className="font-black text-slate-900 dark:text-white">{Number(totals.activeRelationships || 0).toLocaleString('tr-TR')}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Düşük örneklem uzman</span>
          <span className="font-black text-slate-900 dark:text-white">{hiddenLowSample.toLocaleString('tr-TR')}</span>
        </li>
      </ul>
    </section>
  );
}
